<template>
  <div class="payment-wechat-container">
    <div class="payment-wechat-content">
      <div class="payment-wechat-header">
        <h2>微信支付设置</h2>
        <p>配置微信支付相关参数</p>
      </div>
      
      <!-- 帮助文档 -->
      <div class="help-document">
        <span class="help-title">帮助文档</span>
        <el-button type="text" @click="helpVisible = !helpVisible" style="float: right;">
          {{ helpVisible ? '收起' : '展开' }}
        </el-button>
      </div>
      <el-card class="help-card" shadow="hover" style="margin-bottom: 20px;">
        <div v-if="helpVisible" class="help-content">
          <h4>微信支付开通流程：</h4>
          <ol>
            <li>登录<a href="https://pay.weixin.qq.com/" target="_blank">微信支付商户平台</a></li>
            <li>注册并认证商户账号</li>
            <li>在商户平台中创建应用</li>
            <li>获取AppID、MCHID等参数</li>
            <li>设置API密钥</li>
            <li>下载API证书</li>
            <li>配置回调地址</li>
          </ol>
          <h4>参数说明：</h4>
          <ul>
            <li><strong>AppID</strong>：微信公众平台或开放平台的应用ID</li>
            <li><strong>MCHID</strong>：微信支付商户号</li>
            <li><strong>API密钥</strong>：在微信支付商户平台设置的API密钥，用于签名验证</li>
            <li><strong>API证书文件</strong>：从微信支付商户平台下载的apiclient_cert.pem文件内容</li>
            <li><strong>API密钥文件</strong>：从微信支付商户平台下载的apiclient_key.pem文件内容</li>
            <li><strong>回调地址</strong>：支付结果通知的回调地址，必须是外网可访问的地址</li>
          </ul>
          <h4>证书获取步骤：</h4>
          <ol>
            <li>登录微信支付商户平台</li>
            <li>进入「账户中心」->「API安全」</li>
            <li>点击「下载证书」，按照提示完成操作</li>
            <li>解压下载的证书文件，得到以下文件：
              <ul>
                <li>apiclient_cert.pem：证书文件</li>
                <li>apiclient_key.pem：密钥文件</li>
                <li>rootca.pem：根证书文件（通常不需要）</li>
              </ul>
            </li>
            <li>用记事本打开apiclient_cert.pem文件，复制其内容到「API证书文件」输入框</li>
            <li>用记事本打开apiclient_key.pem文件，复制其内容到「API密钥文件」输入框</li>
          </ol>
        </div>
      </el-card>
      
      <el-form :model="form" label-width="120px">
        <el-form-item label="启用微信支付">
          <el-switch v-model="form.enabled" active-text="启用" inactive-text="禁用"></el-switch>
        </el-form-item>
        
        <el-form-item label="AppID">
          <el-input v-model="form.appId" placeholder="请输入微信AppID"></el-input>
        </el-form-item>
        
        <el-form-item label="商户号(MCHID)">
          <el-input v-model="form.mchId" placeholder="请输入商户号"></el-input>
        </el-form-item>
        
        <el-form-item label="API密钥">
          <el-input v-model="form.apiKey" placeholder="请输入API密钥"></el-input>
        </el-form-item>
        
        <el-form-item label="API证书文件">
          <el-input
            v-model="form.certContent"
            type="textarea"
            :rows="4"
            placeholder="请输入API证书文件内容"
          ></el-input>
          <div class="help-text">从微信支付商户平台下载支付证书，解压取得其中的apiclient_cert.pem用记事本打开并复制文件内容，填至此处</div>
        </el-form-item>
        
        <el-form-item label="API密钥文件">
          <el-input
            v-model="form.keyContent"
            type="textarea"
            :rows="4"
            placeholder="请输入API密钥文件内容"
          ></el-input>
          <div class="help-text">从微信支付商户平台下载支付证书，解压取得其中的apiclient_key.pem用记事本打开并复制文件内容，填至此处</div>
        </el-form-item>
        
        <el-form-item label="回调地址">
          <el-input v-model="form.notifyUrl" placeholder="请输入回调地址"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="saveSettings">保存设置</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PaymentWechat',
  data() {
    return {
      form: {
        enabled: false,
        appId: '',
        mchId: '',
        apiKey: '',
        certContent: '',
        keyContent: '',
        notifyUrl: 'https://www.weixiaobuai.com/api/pay/wechat/notify'
      },
      helpVisible: false
    }
  },
  mounted() {
    this.loadSettings()
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get('/admin/config/payment-wechat')
        if (response.data.code === 200) {
          this.form = response.data.data
        }
      } catch (error) {
        console.error('加载微信支付配置失败:', error)
      }
    },
    async saveSettings() {
      try {
        const response = await axios.put('/admin/config/payment-wechat', this.form)
        if (response.data.code === 200) {
          this.$message.success('设置保存成功')
        } else {
          this.$message.error('保存失败')
        }
      } catch (error) {
        console.error('保存微信支付配置失败:', error)
        this.$message.error('保存失败')
      }
    },
    resetForm() {
      this.loadSettings()
      this.$message.info('表单已重置')
    }
  }
}
</script>

<style scoped>
.payment-wechat-container {
  padding: 20px 0;
}

.payment-wechat-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.payment-wechat-header {
  margin-bottom: 30px;
}

.payment-wechat-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.payment-wechat-header p {
  font-size: 14px;
  color: #aaa;
  margin: 0;
}

.help-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.help-content {
  padding: 10px 0;
}

.help-content h4 {
  margin-top: 15px;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
}

.help-content ol, .help-content ul {
  margin-left: 20px;
  color: #333;
  line-height: 1.5;
}

.help-content strong {
  color: #333;
  font-weight: 600;
}

.help-content a {
  color: #409EFF;
  text-decoration: none;
  font-weight: 500;
}

.help-content a:hover {
  text-decoration: underline;
}

.help-text {
  font-size: 12px;
  color: #888;
  margin-top: 5px;
  line-height: 1.4;
}

.help-title {
  color: #ff4d4f;
  font-weight: bold;
}

.help-document {
  margin-bottom: 10px;
  padding: 10px;
  background: rgba(255,255,255,0.05);
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.1);
}

.help-document::after {
  content: '';
  display: table;
  clear: both;
}
</style>